import { IciLaLuneTypes } from '@nx-icilalune/data/icilalune/types';
import { JsonApiQuery } from '@nx-icilalune/data/access';

export interface IciLaLuneJsonApiQuery extends JsonApiQuery {
  type: IciLaLuneTypes;
}

export const paragraphLinkedContentIncludes = [
  'paragraphs.linked_content.thumbnail',
  'paragraphs.linked_content.business_unit',
  'paragraphs.linked_content.client',
];

export const paragraphMediaIncludes = ['paragraphs.images.fileRef'];

export const paragraphQuoteIncludes = ['paragraphs.author.photo_id'];

export const allParagraphIncludes = [
  ...paragraphLinkedContentIncludes,
  ...paragraphMediaIncludes,
  ...paragraphQuoteIncludes,
];

export const associatedProjectsIncludes = [
  'associated_projects.thumbnail',
  'associated_projects.client',
  'associated_projects.business_unit',
];

export const projetRelationAttributeEnhancers = ['business_unit.name'];

//MENUS
//MAIN MENU

//TERMS
export const domainsQuery: IciLaLuneJsonApiQuery = {
  queryId: 'domains',
  type: 'term--domains',
  fields: {
    ['term--domains']: ['name', 'langcode'],
  },
  filters: {
    isPublished: '1',
  },
};

export const typesQuery: IciLaLuneJsonApiQuery = {
  queryId: 'types',
  type: 'term--types',
  fields: {
    ['term--types']: ['name', 'langcode'],
  },
  filters: {
    isPublished: '1',
  },
};

export const technologiesQuery: IciLaLuneJsonApiQuery = {
  queryId: 'technologies',
  type: 'term--technologies',
  fields: {
    ['term--technologies']: ['name', 'langcode', 'icon_id'],
  },
  filters: {
    isPublished: '1',
  },
};

export const businessUnitQuery: IciLaLuneJsonApiQuery = {
  queryId: 'business_unit',
  type: 'term--business_unit',
  fields: {
    ['term--business_unit']: ['name', 'langcode'],
  },
  filters: {
    isPublished: '1',
  },
};

export const termQueries = [
  domainsQuery,
  typesQuery,
  technologiesQuery,
  businessUnitQuery,
];

//PAGES

//SOLUTIONS

//CLIENTS

//NEWS

//AGENCY

//PROJECT
